
import { Component } from '@angular/core';
import { ScorecardComponent } from '../../components/scorecard/scorecard.component';

@Component({
    selector: 'app-scorecard-scores',
    imports: [ScorecardComponent],
    templateUrl: './scorecard-scores.component.html',
    styleUrl: './scorecard-scores.component.scss'
})
export class ScorecardScoresComponent {
}
